import { createSlotRecipe } from './runtime';

const dialogConfig = {"name":"dialog","slots":["backdrop","panel","head","glyph","titles","title","subtitle","close","body","foot"],"defaultVariants":{"size":"md","tone":"default"},"variantMap":{"size":["lg","md","sm"],"tone":["danger","default","warning"]}}

export const dialog = /* @__PURE__ */ createSlotRecipe(dialogConfig)